'use client';

import React, { useEffect } from 'react';
import { Helmet } from '../../components/Helmet';
import { BookingLayout } from '../../containers/BookingJourney';
import { LandingMain } from '../../containers/BookingJourney/components/landing';
import { BASE_URL } from '../../constants';
import { useFiltersStore } from '../../containers/BookingJourney/context';
import { useSegmentPage } from '../../hooks/useSegmentPage';
import HeroImgMobile from '../../containers/BookingJourney/assets/DropIn_Mobile.png';
import HeroImgDesktop from '../../containers/BookingJourney/assets/DropIn_Desktop.png';
import { PetWalkingLinks } from '../../containers/BookingJourney/components/landing/service-links/links';
import { dropInsFaqsData } from '../../data/drop-ins-faqs';
import { useSetIsOnDemand } from '../../hooks';
import { tryCatch } from '../../utils';
import { getServicePageResponse } from '../../hooks/api/getServicePageData';
const meta = {
  title: 'Trusted Pet Caregivers for Drop-Ins Near You | Wag!',
  description: 'Drop-In Visits in your home. A quick visit for dogs who don’t need a walk, but love having friends over. Pawfect for low-maintenance dogs and house tasks.'
};
const PetDropIns = ({
  modal
}) => {
  const canonicalUrl = `${BASE_URL}/drop-ins`;
  const setFilters = useFiltersStore(state => state.setFilters);
  useEffect(() => {
    setFilters({
      service: 'drop-in'
    });
  }, [setFilters]);
  useSetIsOnDemand(true);
  const {
    execute: executeSegmentPage
  } = useSegmentPage();
  useEffect(() => {
    executeSegmentPage({
      name: 'Booking Journey - Dog Drop-In Landing'
    });
  }, [executeSegmentPage]);
  return <>
      <Helmet canonical={canonicalUrl} title={meta.title} description={meta.description} robots="index, follow" openGraph={{
      description: meta.description,
      title: meta.title,
      siteName: 'WagWalking',
      type: 'website',
      url: canonicalUrl
    }} twitter={{
      title: meta.title,
      description: meta.description,
      site: '@WagWalking'
    }} data-sentry-element="Helmet" data-sentry-source-file="index.tsx" />
      <LandingMain heroProps={{
      heroMobileImg: HeroImgMobile,
      heroDesktopImg: HeroImgDesktop,
      taglineLink: '/dog-walking',
      tagline: 'Pet Walking',
      taglineText: 'Looking for a caregiver to take your pet for a walk? ',
      heroTitleProps: {
        title: 'Book pet Drop-In visits'
      }
    }} {...modal && {
      promoModalProps: {
        headerText: modal.title,
        subHeaderText: modal.caption,
        promoCode: modal.promoCode,
        offerExpiry: modal.expiration,
        msBeforeShow: modal.msBeforeShow
      }
    }} wagStates={{
      title: `Trusted pet caregivers near you`
    }} howToBookProps={{
      howToBookTitle: 'How Pet Drop-In visits works'
    }} serviceLinks={{
      LinkSection: PetWalkingLinks
    }} descriptionProps={{
      descriptionTitle: 'What makes Pet Drop-Ins with Wag! so great?'
    }} localExpertProps={{
      serviceType: 'Drop-In',
      localExpertTitle: 'Pet Drop-Ins with local experts you can trust'
    }} faqProps={{
      items: dropInsFaqsData
    }} serviceDescription={{
      title: 'Trusted local pet caregivers',
      description: "Book with a highly-rated pet caregiver who will care for your pets in your home when you're out of town. Whether it's just for the weekend, date night, or several weeks, local dog sitters and Pet Caregivers on Wag! are available to help."
    }} data-sentry-element="LandingMain" data-sentry-source-file="index.tsx" />
    </>;
};
PetDropIns.Layout = BookingLayout;
export const getStaticProps = async () => {
  const slug = 'drop-ins';
  const [servicePageResponse] = await tryCatch(() => getServicePageResponse(slug));
  return {
    props: {
      tailwind: true,
      ...(servicePageResponse?.modal && {
        modal: servicePageResponse.modal
      })
    },
    revalidate: 10 // Revalidate every 10 seconds
  };
};
export default PetDropIns;